// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "::-webkit-scrollbar{width:6px;height:6px}::-webkit-scrollbar-track{border-radius:5px;background:rgba(20,28,32,.05)}::-webkit-scrollbar-thumb{background:rgba(20,28,32,.3);border-radius:5px;outline:none}", ""]);
// Exports
module.exports = exports;
